import Icon from 'veui/components/Icon'
import { IconRotateAnticlockwise } from 'dls-icons-vue'

Icon.register('rotate-anticlockwise', IconRotateAnticlockwise)
